import { render, staticRenderFns } from "./IndustrialIntegrationErrorDetail.vue?vue&type=template&id=773210e4&scoped=true"
import script from "./IndustrialIntegrationErrorDetail.vue?vue&type=script&lang=js"
export * from "./IndustrialIntegrationErrorDetail.vue?vue&type=script&lang=js"
import style0 from "./IndustrialIntegrationErrorDetail.vue?vue&type=style&index=0&id=773210e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773210e4",
  null
  
)

export default component.exports